import React from 'react';

import bg404 from '@assets/images/bg-404.png';
import { ReactComponent as ErrorPageIcon } from '@assets/svg/ic-error-page.svg';

import Button from '@components/uikit/Button/Button';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const Error404 = () => {
  const { t } = useTranslation();

  return (
    <div className={style.errorPage}>
      <div className={style.errorPageBgWrapper}>
        <img src={bg404} className={style.errorPageBgWrapperImage} alt="bg-404" />
      </div>
      <div className={style.errorPageBlock}>
        <ErrorPageIcon className={style.errorIcon} />
        <div className={style.errorPageTitle}>
          {t(`Oops! It seems you've stumbled upon a 404 error page.`)}
        </div>
        <div className={style.errorPageDesc}>
          {t(
            `We apologize for the inconvenience. The content you're looking for is currently unavailable or may have been moved.`,
          )}{' '}
          {t('If you need assistance, please contact our support team at')}{' '}
          <a href="mailto:support@waites.net" className={style.errorPageSupportLink}>
            support@waites.net.
          </a>
        </div>

        <div className={style.errorPageActions}>
          <Button
            type="primary"
            text={t('Home page')}
            onClick={() => {
              window.location.href = window.location.origin;
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default Error404;